import FoldersDocumentTypeModalView from "./foldersDocumentTypeModal.html";
import FoldersTagsModalView from "./foldersTagsModal.html";
import TagsModalView from "../tags/TagsModal.html";
import FoldersEditModalView from "./folders-edit.html";
import FilesEditModalView from "./files-edit.html";


angular.module("folders")

    .controller('FoldersListCtrl', ['entity_type', 'entity_type_id','is_public', 'foldersService', '$stateParams', '$rootScope', '$scope', 'Restangular', 'modalService', '$filter', 'LoginService', '$uibModal', 'clipboard', 'generateDocumentService', '$http', 'logService',
        function (entity_type, entity_type_id, is_public, foldersService, $stateParams, $rootScope, $scope, Restangular, modalService, $filter, LoginService, $uibModal, clipboard, generateDocumentService, $http, logService) {

            $scope.currentFolderId = null;
            let options: any = {};
            let fullFolderFiles: any = null;

            $scope.tagsInFilter = [];

            if ($stateParams.id && typeof ($stateParams.id) !== 'undefined') {
            if (entity_type == "events") {
                Restangular.one('Events', $stateParams.id).get().then(function (results) {
                    //event = results;
                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('events.title'), url: "events.list" },
                        { title: results.name, url: "events.edit({ id: " + results.id + " })" },
                        { title: $filter('translate')('folders.list') }
                    ];
                    $rootScope.title = results.name + " - " + $filter('translate')('folders.list');
                });
            }
            if (entity_type == "persons") {
                Restangular.one('Persons', $stateParams.id).get().then(function (results) {
                    // event = results;
                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('events.title'), url: "events.list" },
                        { title: results.name, url: "person.edit({ id: " + results.id + ", person_type: " + $stateParams.person_type +" })" },
                        { title: $filter('translate')('folders.list') }
                    ];
                    $rootScope.title = results.name + " - " + $filter('translate')('folders.list');
                });
            }
        } else {
            $rootScope.title = $filter('translate')('folders.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('folders.list') }
            ];
        }        

        $scope.breadcrumb = function (folderId) {
            options = { id: folderId, entity_type: entity_type, entity_type_id: entity_type_id };
            $scope.currentFolderId = folderId;
            Restangular.all("Folders").customGET("FoldersBreadcrumb", options).then(function (results) {
                $scope.breadcrumbs = results;
            });
        };
        $scope.breadcrumb($scope.currentFolderId);

        $scope.loadData = function (folderId) {
            options = { folder_id: folderId, entity_type: entity_type, entity_type_id: entity_type_id, is_public: is_public };
            $scope.currentFolderId = folderId;
            Restangular.all("Folders").getList(options).then(function (results) {
                fullFolderFiles = results;
                $scope.foldersFiles = results;
                $scope.breadcrumb($scope.currentFolderId);//recargamos el breadcrumb
                //Cargamos los tags
                Restangular.all('Tags').getList({ entity_type: "documents" }).then(function (tags) {
                    $scope.selectTags = tags;
                    // Mostramos solo los tags que hay en los archivos para el filtro
                    $scope.tagList = filterUsedTags(tags, results);
                });
            });
        };
            $scope.loadData($scope.currentFolderId);

            // To do 
            $scope.setDocumentType = function (folderfile) {
                $scope.$modalInstance = $uibModal.open({
                    animation: true,
                    template: FoldersDocumentTypeModalView,
                    size: "md",
                    controller: "FoldersDocumentTypeCtrl",
                    scope: $scope,
                    resolve: {
                        folderfile: function () {
                            return folderfile;
                        },
                    }
                });
            };

        // Gestión de tags 
            $scope.manageTags = function (folder) {
                $scope.$modalInstance = $uibModal.open({
                    animation: true,
                    template: FoldersTagsModalView,
                    size: "md",
                    controller: "FoldersTagsModalCtrl",
                    scope: $scope,
                    resolve: {
                        folder: function () {
                            return folder;
                        },
                    }
                });
            }

            $scope.createNewTag = function () {
                $scope.$modalInstance = $uibModal.open({
                    animation: true,
                    template: TagsModalView,
                    size: "ld",
                    controller: "tagsModalCtrl",
                    scope: $scope,
                    resolve: {

                        is_search: function () {
                            return false
                        },

                        selected_tags_ids: function () {
                            return [];
                        },

                        entity_type: function () {
                            return "documents";
                        },
                        entity_id: function () {
                            return null;
                        }

                    }
                });
            }

            $scope.filterByTags = function () {
                let tagsInFilterIds = $scope.tagsInFilter.map(t => t.id);
                logService.debug(tagsInFilterIds);
                 $scope.foldersFiles = fullFolderFiles.filter((file) => tagsInFilterIds.every(t => file.tags.map(m => m.tag_id).includes(t))
                     || (file.subFolderTagsIds && tagsInFilterIds.every(t => file.subFolderTagsIds.concat(file.tags.map(m => m.tag_id)).includes(t))));
                 
            };

            $scope.addTagToFilter = function (tag) {
                if (!$scope.tagsInFilter.map(t => t.id).includes(tag.id))
                    $scope.tagsInFilter.push(tag);

                $scope.filterByTags();
            };

            $scope.removeTagFromFilter = function (tag) {
                let index = $scope.tagsInFilter.indexOf(tag);
                $scope.tagsInFilter.splice(index, 1);
                $scope.filterByTags();
            };



        $scope.editAdd = function (type, id) {
            if (type == 'folder') {
                $scope.$modalInstance = $uibModal.open({
                    animation: true,
                    template: FoldersEditModalView,
                    size: "md",
                    controller: "FoldersEditModalCtrl",
                    scope: $scope,
                    resolve: {
                        folderId: function () {
                            return id;
                        },
                        parentFolderId: function () {
                            return $scope.currentFolderId;
                        },
                        entity_type: function () {
                            return entity_type
                        },
                        entity_type_id: function () {
                            return entity_type_id
                        },
                        is_public: function () {
                            return is_public
                        }
                    }
                });
            } else {
                $scope.$modalInstance = $uibModal.open({
                    animation: true,
                    template: FilesEditModalView,
                    size: "md",
                    controller: "FilesEditModalCtrl",
                    scope: $scope,
                    resolve: {
                        fileId: function () {
                            return id;
                        },
                        parentFolderId: function () {
                            return $scope.currentFolderId;
                        },
                        entity_type: function () {
                            return entity_type
                        },
                        entity_type_id: function () {
                            return entity_type_id
                        },
                        is_public: function () {
                            return is_public
                        }
                    }
                });
            }

           //Response del modal
            $scope.$modalInstance.result.then(function (data) {
                    $scope.loadData($scope.currentFolderId);
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();
                });  
        };

        $scope.delete = function (type, id, name) {
            if (type == "folder") {
                modalService.confirm({
                    title: $filter('translate')('folders.title_delete'),
                    message: $filter('translate')('folders.delete_message') + " " + name + "?",
                    onAccept: function () {
                        Restangular.one('Folders', id).remove().then(function () {
                            toastr.success($filter('translate')('folders.delete_success'));
                            $scope.loadData($scope.currentFolderId);
                        });
                    }
                });
            } else {
                modalService.confirm({
                    title: $filter('translate')('files.title_delete'),
                    message: $filter('translate')('files.delete_message') + " " + name + "?",
                    onAccept: function () {
                        Restangular.one('Files', id).remove().then(function () {
                            toastr.success($filter('translate')('files.delete_success'));
                            $scope.loadData($scope.currentFolderId);
                        });
                    }
                });
            }
        };

        $scope.downloadAll = function () {
            alert("downloadAll " + $scope.currentFolderId);
        };

        $scope.copyToClipboard = function (uid) {
            if (!clipboard.supported) {
                alert("/api/files/" + uid + "/download");
            } else {
                clipboard.copyText(location.protocol + "//" + location.host + "/api/files/" + uid + "/download");
            }
        };

        $scope.openFile = function (uid) {
            window.open("/api/files/" + uid + "/download", '_blank');
        };

        $scope.onCancel = function () {
            //$uibModalInstance.dismiss('cancel');
            foldersService.onClose();
            };

            $scope.changeIsGuestOnly = function (folderFile) {
                // Actualizamos el objeto Local 
                folderFile.guest_only == false ? folderFile.guest_only = true : folderFile.guest_only = false;
                // Actualizamos la BBDD
                let type;
                folderFile.is_folder ? type = 'Folders' : type = 'Files';
                Restangular.one(`${type}`, folderFile.id).get().then(function (result) {
                    result.guest_only = folderFile.guest_only;
                    result.put();
                })
            };

        $scope.printDialog = function (code, type_document, type_result, id) {
            var params = {
                id: $scope.currentFolderId,
                entity_type: entity_type,
                entity_type_id: entity_type_id,
                documents: { codes: [code] }
            };
            generateDocumentService.documentNew({
                params: params,
                onAccept: function (data) {
                    angular.forEach(data, function (item) {
                        //url = (window as any).CONFIG.api_url + 'documentgenerator/' + item.document_url_method + '/' + item.document_id + '/' + params.id + '/' + params.entity_type + '/' + params.entity_type_id + '/pdf';
                        //logService.debug(url);
                        //window.open(url, '_blank');
                        $http({
                            method: 'post',
                            url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                            params: { document_id: item.document_id, outputType: 'pdf' }
                        }).then(function (result, status, headers, config) {
                            var url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                            window.open(url, '_blank');
                        });
                    })
                }
            });
        };

        // Funciones auxiliares 
        let filterUsedTags = function (tagList, folderList) {
            let availableTags = [];
            folderList.forEach(function (f) {
                let folderTags = f.tags.map(t => t.tag_id);
                if(folderTags!=null) availableTags = mergeWithoutDuplicates(availableTags, folderTags);
                let subfolderTags = f.subFolderTagsIds;
                if(subfolderTags) availableTags = mergeWithoutDuplicates(availableTags, subfolderTags);
            });
            return tagList.filter((f) => availableTags.includes(f.id))
        };

        let mergeWithoutDuplicates = function (array1, array2) {
            if (!array1 || array1.length < 1) return array2;
            if (!array2 || array2.length < 1) return array1;
            return array1.concat(array2.filter((item) => array1.indexOf(item) < 0))
        };

    }])

    .controller('FoldersTagsModalCtrl', ['folder', '$scope', 'Restangular',
        function (folder, $scope, Restangular) {

            $scope.managedFolder = {};
            $scope.managedFolder = folder;
            $scope.tagToAdd = {};

            $scope.addTagToFolder = function (tag) {
               $scope.tagToAdd.selected = null;

               if (!folder.tags.map(t => t.tag_id).includes(tag.id)) {
                    let entity_type = folder.is_folder ? 'folder' : 'file';
                    let tagEntity: any = { tag_id: tag.id, entity_type: entity_type, entity_id: folder.id, color: tag.color, title: tag.title, description: tag.description, icon: tag.icon };
                    Restangular.all('Folders/addTag').post(tagEntity).then(function (id) {
                        tagEntity.id = id;
                        $scope.managedFolder.tags.push(tagEntity);
                        $scope.loadData($scope.currentFolderId);
                    });
                }
            };

            $scope.removeTagFromFolder = function (tag) {
                let index = $scope.managedFolder.tags.indexOf(tag);
                Restangular.all('Folders/removeTag').post(tag).then(function () {
                    $scope.managedFolder.tags.splice(index, 1)
                    $scope.loadData($scope.currentFolderId);
                });
            };

            $scope.onCancel = function () {
                $scope.$modalInstance.dismiss('cancel');
            };

        }])

    .controller('FoldersDocumentTypeCtrl', ['folderfile', '$scope', 'Restangular',
        function (folderfile, $scope, Restangular) {


            $scope.managedFolder = folderfile;
            // Cargamos los tipos de documentos para poder asignarlos al archivo
            if (!$scope.selectDocumentTypes) {
                Restangular.all('DocumentsTypes').getList().then(function (result) {
                    $scope.selectDocumentTypes = result;
                });
            }

            Restangular.one('Files', folderfile.id).get().then(function (result) {
                $scope.managedFile = result;
            });

            $scope.onCancel = function () {
                $scope.$modalInstance.dismiss('cancel');
                $scope.managedFile = {};
                $scope.managedFolder = {};
            };

            $scope.onAccept = function () {
                Restangular.all("Files").customGET("changeDocumentType", { fileId: $scope.managedFile.id, documentTypeId: $scope.managedFile.DocumentTypeId }).then(function (res) {
                    $scope.managedFile = {};
                    $scope.managedFolder = {};
                    $scope.$modalInstance.close();
                });
            }
        }])
;